/**
 * In-memory cache for dashboard GET responses for the current SPA session.
 * ASSUMPTION: Cached data is scoped to the current user token; cache is cleared on logout.
 */

const store = new Map<string, unknown>();

export function getSessionRequestCache<T>(key: string): T | undefined {
  return store.get(key) as T | undefined;
}

export function setSessionRequestCache<T>(key: string, value: T): void {
  store.set(key, value);
}

export function clearSessionRequestCache(): void {
  store.clear();
}

/** Removes keys that start with the given prefix (e.g. "catalog:"). */
export function invalidateSessionRequestCachePrefix(prefix: string): void {
  Array.from(store.keys()).forEach((key) => {
    if (key.startsWith(prefix)) {
      store.delete(key);
    }
  });
}
